import React from 'react';
import PropTypes from 'prop-types';
import Text from './Text.jsx';

/**
 * Secondary copy — a label above a figure, a count beside it, a "Target: 40%" hint. The colour is
 * fixed, so a caller cannot drift to another grey; everything else goes through to `Text`.
 *
 * For the small explanatory line that sits between blocks, use `Caption` instead: it also owns
 * its spacing.
 */
const MutedText = ({children, ...props}) => {
  return (
    <Text {...props} color="muted">
      {children}
    </Text>
  );
};

MutedText.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(['xs', 'small', 'regular']),
  weight: PropTypes.oneOf(['normal', 'semibold', 'bold']),
  truncate: PropTypes.bool,
  strikethrough: PropTypes.bool,
  as: PropTypes.elementType,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default MutedText;
